import React from 'react'

import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import PageLoader from '../../components/ui/pageLoader/PageLoader'


const ProtectedRoute = ({ children }) => {

  const { isLogedin, isAuthenticated, isAuthLoading  } = useSelector((state) => state.auth)

  if (isAuthLoading) return <PageLoader />;
  
  if (!isLogedin && !isAuthenticated) {
    return <Navigate to="/login" />;

  }
  return children;
}

export default ProtectedRoute